const carouselImages = [
    require('../../Images/team/Teampic1.jpg'),
    require('../../Images/team/Teampic2.jpg'),
    require('../../Images/team/Teampic3.jpg'),
    require('../../Images/team/Teampic4.jpg')
  ];
  
  export default carouselImages;